<template>
  <el-dialog title="登录" width="30%" :visible.sync="visible" :close-on-click-modal="false"
    :close-on-press-escape="false" :show-close="showClose" @close="close">
    <div class="form-box">
      <login-default v-if="site_msg.loginType === 1" @success="handleLoginNext" @fail="loginFailed"></login-default>
      <login-identity v-else-if="site_msg.loginType === 2" @success="handleLoginNext" @fail="loginFailed"></login-identity>
      <login-signid v-else-if="site_msg.loginType === 3" @success="handleLoginNext" @fail="loginFailed"></login-signid>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { Dialog } from 'element-ui'
import LoginDefault from '@/components/Login/LoginDefault'
import LoginIdentity from '@/components/Login/LoginIdentity'
import LoginSignid from '@/components/Login/LoginSignid'
import { loginEvent, sensor } from '@/utils/sensor'
// import * as Sentry from '@sentry/browser'

export default {
  components: {
    ElDialog: Dialog,
    LoginDefault,
    LoginIdentity,
    LoginSignid
  },
  props: {
    visible: Boolean,
    showClose: Boolean
  },
  data() {
    return {
      tab: ''
    }
  },
  computed: {
    ...mapState(['user', 'site_msg'])
  },
  methods: {
    close() {
      this.$emit('close')
    },
    // 登录成功后处理
    handleLoginNext(userInfo) {
      localStorage.examId = ''
      this.$store.commit('HAS_TOKEN', true)
      this.$store.commit('SET_USER', userInfo)
      localStorage.setItem('user_id', userInfo.id)
      loginEvent(userInfo)
      this.$emit('success')
      // Sentry.captureEvent({
      //   message: '登录弹窗，登录成功',
      //   extra: userInfo.id
      // })
      sensor.track('login_success', {
        user_id: userInfo.id
      })
    },
    loginFailed(e) {
      // Sentry.captureEvent({
      //   message: '登录弹窗，登录失败',
      //   extra: e
      // })
      sensor.track('login_failed', {
        error: e
      })
    }
  },
  async mounted() {

  }
}
</script>

<style lang="scss" scoped>
.form-box {
  width: 360px;
  margin: 0 auto;
  padding-bottom: 20px;
}
</style>
